import React from 'react';
import { createRoot } from 'react-dom/client';
import SimpleReactLightbox from 'simple-react-lightbox';
import App from './App';
import './index.scss';
import reportWebVitals from './reportWebVitals';

const root = createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <SimpleReactLightbox>
            <App />
        </SimpleReactLightbox>
    </React.StrictMode>
);

reportWebVitals();
